import React from 'react'
import { LogError } from '../../../Services/LoggerService'
import { useConfig } from '../../../Providers/ConfigProvider'

const useLogger = () => {
    const { api } = useConfig()

    const logError = (errorMessage) => {
        LogError(api, errorMessage).then(res => { }).catch(e => { console.log(e) })
    }

    return { logError }
}

export default useLogger